export const STORYBOARD_CREATED = 'STORYBOARD_CREATED';
export const PROMPT_EDITOR_DATA_REQUEST = 'PROMPT_EDITOR_DATA_REQUEST';
export const PROMPT_EDITOR_DATA = 'PROMPT_EDITOR_DATA';